var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "spinner",
      "color": "#3ba9f3",
      "size": "60",
      "active": _vm.LoaderForPrefill
    },
    on: {
      "update:active": function($event) {
        _vm.LoaderForPrefill = $event
      }
    }
  }), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('h4', {
    staticClass: "header"
  }, [_vm._v("Contracted Services")]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('b-tabs', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "content-class": "mt-2"
    }
  }, [_c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "FTL (Full Truck Load) Services",
      "title-link-class": _vm.linkClass(0)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('FTL')
      }
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Booking Type")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLSurface),
      expression: "FTLSurface"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLSurface"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLSurface) ? _vm._i(_vm.FTLSurface, null) > -1 : (_vm.FTLSurface)
    },
    on: {
      "click": function($event) {
        _vm.chkFTLRouteMode()
      },
      "__c": function($event) {
        var $$a = _vm.FTLSurface,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLSurface = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLSurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLSurface = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Surface")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLServiceArray),
      expression: "FTLServiceArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLForward",
      "value": "Forward",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLServiceArray) ? _vm._i(_vm.FTLServiceArray, "Forward") > -1 : (_vm.FTLServiceArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLServiceArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Forward",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLServiceArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLServiceArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLServiceArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Forward")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLBookingArray),
      expression: "FTLBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLCredit",
      "value": "Credit"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLBookingArray) ? _vm._i(_vm.FTLBookingArray, "Credit") > -1 : (_vm.FTLBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Credit",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Credit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLBookingArray),
      expression: "FTLBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLPay",
      "value": "To Pay"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLBookingArray) ? _vm._i(_vm.FTLBookingArray, "To Pay") > -1 : (_vm.FTLBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "To Pay",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("FTC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.FTLBookingArray),
      expression: "FTLBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "FTLPrePaid",
      "value": "PrePaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.FTLBookingArray) ? _vm._i(_vm.FTLBookingArray, "PrePaid") > -1 : (_vm.FTLBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForFTL,
      "__c": function($event) {
        var $$a = _vm.FTLBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PrePaid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.FTLBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.FTLBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.FTLBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Prepaid")])])])])])])])])]), _vm._v(" "), _c('b-tab', {
    staticClass: "tab-content1 tab-header1",
    attrs: {
      "title": "PTL (Part Truck Load) Services",
      "title-link-class": _vm.linkClass(1)
    },
    on: {
      "click": function($event) {
        _vm.changeTab('PTL')
      }
    }
  }, [_c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Route Mode")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_vm._v("Booking Type")])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurface),
      expression: "PTLSurface"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLSurface"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurface) ? _vm._i(_vm.PTLSurface, null) > -1 : (_vm.PTLSurface)
    },
    on: {
      "click": _vm.chkPTLrouteModeSurface,
      "__c": function($event) {
        var $$a = _vm.PTLSurface,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurface = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurface = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurface = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Surface")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfServiceArray),
      expression: "PTLSurfServiceArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLForward",
      "value": "Forward",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfServiceArray) ? _vm._i(_vm.PTLSurfServiceArray, "Forward") > -1 : (_vm.PTLSurfServiceArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfServiceArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Forward",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfServiceArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfServiceArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfServiceArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Forward")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfBookingArray),
      expression: "PTLSurfBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLCredit",
      "value": "Credit"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfBookingArray) ? _vm._i(_vm.PTLSurfBookingArray, "Credit") > -1 : (_vm.PTLSurfBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Credit",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Credit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfBookingArray),
      expression: "PTLSurfBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPay",
      "value": "To Pay"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfBookingArray) ? _vm._i(_vm.PTLSurfBookingArray, "To Pay") > -1 : (_vm.PTLSurfBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "To Pay",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("FTC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLSurfBookingArray),
      expression: "PTLSurfBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPrePaid",
      "value": "PrePaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLSurfBookingArray) ? _vm._i(_vm.PTLSurfBookingArray, "PrePaid") > -1 : (_vm.PTLSurfBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLSurfBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PrePaid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLSurfBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLSurfBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLSurfBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Prepaid")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAir),
      expression: "PTLAir"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLAir"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAir) ? _vm._i(_vm.PTLAir, null) > -1 : (_vm.PTLAir)
    },
    on: {
      "click": _vm.chkPTLrouteModeAir,
      "__c": function($event) {
        var $$a = _vm.PTLAir,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAir = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAir = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAir = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Air")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirServiceArray),
      expression: "PTLAirServiceArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLForward",
      "value": "Forward",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirServiceArray) ? _vm._i(_vm.PTLAirServiceArray, "Forward") > -1 : (_vm.PTLAirServiceArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirServiceArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Forward",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirServiceArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirServiceArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirServiceArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Forward")])])])])]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirBookingArray),
      expression: "PTLAirBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLCredit",
      "value": "Credit"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirBookingArray) ? _vm._i(_vm.PTLAirBookingArray, "Credit") > -1 : (_vm.PTLAirBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "Credit",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Credit")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirBookingArray),
      expression: "PTLAirBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPay",
      "value": "To Pay"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirBookingArray) ? _vm._i(_vm.PTLAirBookingArray, "To Pay") > -1 : (_vm.PTLAirBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "To Pay",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("FTC")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    attrs: {
      "disabled": _vm.disabledPTL
    }
  }, [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PTLAirBookingArray),
      expression: "PTLAirBookingArray"
    }],
    attrs: {
      "type": "checkbox",
      "id": "PTLPrePaid",
      "value": "PrePaid"
    },
    domProps: {
      "checked": Array.isArray(_vm.PTLAirBookingArray) ? _vm._i(_vm.PTLAirBookingArray, "PrePaid") > -1 : (_vm.PTLAirBookingArray)
    },
    on: {
      "click": _vm.createAccordianDataForPTL,
      "__c": function($event) {
        var $$a = _vm.PTLAirBookingArray,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "PrePaid",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.PTLAirBookingArray = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.PTLAirBookingArray = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.PTLAirBookingArray = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _c('label', [_vm._v("Prepaid")])])])])])])])])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isServiceSelected),
      expression: "!isServiceSelected"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Please Select Atleast One Service\n              ")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-headerfrm1"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Service Levels")]), _vm._v(" "), (_vm.loadaccordian) ? _c('table', {
    staticClass: "styled-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Truck Load Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Route Mode ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Service Type")])]), _vm._v(" "), _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Booking Type ")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Action")])]), _vm._v(" "), (_vm.ptlerror || _vm.ftlerror) ? _c('th', {
    staticClass: "text-left tableheader"
  }, [_c('b', [_vm._v("Error")])]) : _vm._e()])]), _vm._v(" "), (_vm.accordiandata.length == 0) ? _c('tbody', [(_vm.accordiandata.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("No Records Found")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.accordiandata), function(data, index) {
    return (_vm.accordiandata.length > 0) ? _c('tbody', [_c('tr', {
      attrs: {
        "id": _vm.loadtab + index
      }
    }, [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.loadtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.routemode))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.servicetype))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(data.bokkingtype.join(", ")))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      attrs: {
        "title": "Edit"
      },
      on: {
        "click": function($event) {
          _vm.ShowServiceDetails(index, data.key, data.loadtype)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      staticStyle: {
        "font-size": "14px",
        "cursor": "pointer"
      }
    })])]), _vm._v(" "), (_vm.ptlerror || _vm.ftlerror) ? _c('td', {
      staticClass: "text-danger",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Validation Error")]) : _vm._e()]), _vm._v(" "), (_vm.opened.includes(index)) ? _c('tr', {
      attrs: {
        "colspan": 6,
        "id": 'innerTable' + index
      }
    }, [_c('td', {
      attrs: {
        "colspan": 6
      }
    }, [_c('b-card', [(_vm.loadtab == 'FTL') ? _c('div', [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Select Service Type "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-credit-card'></i>"
      }
    }, [_c('treeselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.ServiceTypeDropdown,
        "placeholder": "Select Service Type",
        "append-to-body": true,
        "name": "servicetype"
      },
      on: {
        "select": function($event) {
          _vm.SelectServiceType($event, 'ftl', data.key)
        }
      },
      model: {
        value: (_vm.ftlObject[data.key].servicetypezonetozonecitytocity),
        callback: function($$v) {
          _vm.ftlObject[data.key].servicetypezonetozonecitytocity = $$v
        },
        expression: "ftlObject[data.key].servicetypezonetozonecitytocity"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('servicetype')),
        expression: "errors.has('servicetype')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please choose Service Type.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loadtab == 'FTL' && _vm.clientcontract == 0 && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 1) ? _c('div', [_c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Select Service Level "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListCitytoCity,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": false
      },
      on: {
        "select": function($event) {
          _vm.selectServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ftlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ftlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ftlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1), _vm._v(" "), (_vm.ftlObject[data.key].serviceLevel.id) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City)")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ftlObject[data.key].error != ''),
        expression: "ftlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].error))])]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'FTL' && _vm.clientcontract == 0 && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 2) ? _c('div', [_c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Select Service Level  "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListZonetoZone,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": false
      },
      on: {
        "select": function($event) {
          _vm.selectServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ftlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ftlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ftlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1), _vm._v(" "), (_vm.ftlObject[data.key].serviceLevel.id) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone) ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ftlObject[data.key].error != ''),
        expression: "ftlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].error))])]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'FTL' && _vm.clientcontract == 1 && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 1) ? _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ftlObject[data.key].UpdateSalesTatType),
        expression: "ftlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "ServiceLevelTemplate",
        "value": "ServiceLevelTemplate",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ftlObject[data.key].UpdateSalesTatType, "ServiceLevelTemplate")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ftl', data.key)
        },
        "__c": function($event) {
          _vm.ftlObject[data.key].UpdateSalesTatType = "ServiceLevelTemplate"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "ServiceLevelTemplate"
      }
    }, [_vm._v("Select Service Level ")]), _vm._v("     \n                                  ")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListCitytoCity,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": _vm.ftlObject[data.key].UpdateSalesTatType == 'ServiceLevelTemplate' ? false : true
      },
      on: {
        "select": function($event) {
          _vm.selectServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ftlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ftlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ftlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1), _vm._v(" "), ((_vm.ftlObject[data.key].servicetypezonetozonecitytocity == 1 && (_vm.ftlObject[data.key].showSalesTatDownload == true || _vm.ftlObject[data.key].serviceLevel.id) && (_vm.ftlObject[data.key].ischanged == 1))) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City)")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ftlObject[data.key].UpdateSalesTatType),
        expression: "ftlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "UploadFile",
        "value": "FileUpload",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ftlObject[data.key].UpdateSalesTatType, "FileUpload")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ftl', data.key)
        },
        "__c": function($event) {
          _vm.ftlObject[data.key].UpdateSalesTatType = "FileUpload"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _c('label', {
      attrs: {
        "for": "UploadFile"
      }
    }, [_vm._v("Upload File")])])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + data.key
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + data.key,
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file",
        "disabled": _vm.ftlObject[data.key].UpdateSalesTatType == 'FileUpload' ? false : true
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFile($event, 'ftl', data.key)
        }
      }
    }), _vm._v("  \n                                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.ftlObject[data.key].filename) + "\n                                ")])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [((_vm.ftlObject[data.key].servicetypezonetozonecitytocity == 1 && (_vm.ftlObject[data.key].showSalesTatDownload == true || _vm.ftlObject[data.key].serviceLevel.id) && (_vm.ftlObject[data.key].ischanged == 0))) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City)")])]) : _vm._e()]), _vm._v(" "), (_vm.ftlObject[data.key].isupload == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateFile('ftl', data.key)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].validdatacount))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ftlObject[data.key].invaliddatacount))])])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1 && _vm.ftlObject[data.key].invaliddatacount > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].invaliddatacount > 0 && _vm.ftlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.ftlObject[data.key].tableColumn,
        "items": _vm.ftlObject[data.key].tableItems,
        "offset": _vm.ftlObject[data.key].offset
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ftlObject[data.key].totalPage > 1) ? _c('pagination', {
      attrs: {
        "total-pages": _vm.ftlObject[data.key].totalPage,
        "total": _vm.ftlObject[data.key].totalCount,
        "per-page": _vm.ftlObject[data.key].pageLimit,
        "current-page": _vm.ftlObject[data.key].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, 'ftl', data.key)
        }
      }
    }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ftlObject[data.key].error != ''),
        expression: "ftlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].error))])]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'FTL' && _vm.clientcontract == 1 && _vm.ftlObject[data.key].servicetypezonetozonecitytocity == 2) ? _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ftlObject[data.key].UpdateSalesTatType),
        expression: "ftlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "ServiceLevelTemplate",
        "value": "ServiceLevelTemplate",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ftlObject[data.key].UpdateSalesTatType, "ServiceLevelTemplate")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ftl', data.key)
        },
        "__c": function($event) {
          _vm.ftlObject[data.key].UpdateSalesTatType = "ServiceLevelTemplate"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "ServiceLevelTemplate"
      }
    }, [_vm._v("Select Service Level ")]), _vm._v("     \n                                  ")])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListZonetoZone,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": _vm.ftlObject[data.key].UpdateSalesTatType == 'ServiceLevelTemplate' ? false : true
      },
      on: {
        "select": function($event) {
          _vm.selectServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ftlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ftlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ftlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1), _vm._v(" "), ((_vm.ftlObject[data.key].servicetypezonetozonecitytocity == 2 && (_vm.ftlObject[data.key].showSalesTatDownloadzonetozone == true || _vm.ftlObject[data.key].serviceLevel.id) && (_vm.ftlObject[data.key].ischanged == 1))) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone) ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ftlObject[data.key].UpdateSalesTatType),
        expression: "ftlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "UploadFile",
        "value": "FileUpload",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ftlObject[data.key].UpdateSalesTatType, "FileUpload")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ftl', data.key)
        },
        "__c": function($event) {
          _vm.ftlObject[data.key].UpdateSalesTatType = "FileUpload"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _c('label', {
      attrs: {
        "for": "UploadFile"
      }
    }, [_vm._v("Upload File")])])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-6"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + data.key
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File (Zone to Zone)")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + data.key,
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file",
        "disabled": _vm.ftlObject[data.key].UpdateSalesTatType == 'FileUpload' ? false : true
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFileZonetoZone($event, 'ftl', data.key)
        }
      }
    }), _vm._v("  \n                                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.ftlObject[data.key].filenamezonetozone) + "\n                                ")])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [((_vm.ftlObject[data.key].servicetypezonetozonecitytocity == 2 && (_vm.ftlObject[data.key].showSalesTatDownloadzonetozone == true || _vm.ftlObject[data.key].serviceLevel.id) && (_vm.ftlObject[data.key].ischanged == 0))) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone) ")])]) : _vm._e()]), _vm._v(" "), (_vm.ftlObject[data.key].isuploadzonetozone == 1 && _vm.isinvalid == false) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateFileZoneToZone('ftl', data.key)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidatedzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidatedzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].totalrecordszonetozone))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ftlObject[data.key].validdatacountzonetozone))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ftlObject[data.key].invaliddatacountzonetozone))])])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1 && _vm.ftlObject[data.key].invaliddatacountzonetozone > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].invaliddatacountzonetozone > 0 && _vm.ftlObject[data.key].isvalidatedzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.ftlObject[data.key].tableColumnzonetozone,
        "items": _vm.ftlObject[data.key].tableItemszonetozone,
        "offset": _vm.ftlObject[data.key].offset
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ftlObject[data.key].totalPagezonetozone > 1) ? _c('pagination', {
      attrs: {
        "total-pages": _vm.ftlObject[data.key].totalPagezonetozone,
        "total": _vm.ftlObject[data.key].totalCountzonetozone,
        "per-page": _vm.ftlObject[data.key].pageLimitzonetozone,
        "current-page": _vm.ftlObject[data.key].currentPagezonetozone
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, 'ftl', data.key)
        }
      }
    }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ftlObject[data.key].errorzonetozone != ''),
        expression: "ftlObject[data.key].errorzonetozone!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].errorzonetozone))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "checkbox",
      attrs: {
        "left": "<i class='fa fa-credit-card'></i>"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ftlObject[data.key].uploadadditionalcities),
        expression: "ftlObject[data.key].uploadadditionalcities"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "checkbox",
        "name": "Service Type",
        "value": "2"
      },
      domProps: {
        "checked": Array.isArray(_vm.ftlObject[data.key].uploadadditionalcities) ? _vm._i(_vm.ftlObject[data.key].uploadadditionalcities, "2") > -1 : (_vm.ftlObject[data.key].uploadadditionalcities)
      },
      on: {
        "click": function($event) {
          _vm.changecitytocity(data.key)
        },
        "__c": function($event) {
          var $$a = _vm.ftlObject[data.key].uploadadditionalcities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "2",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ftlObject[data.key].uploadadditionalcities = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ftlObject[data.key].uploadadditionalcities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ftlObject[data.key].uploadadditionalcities = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _c('label', {
      attrs: {
        "for": "Commercial"
      }
    }, [_vm._v("Upload Exceptional lanes    ")])])])], 1), _vm._v(" "), (_vm.ftlObject[data.key].uploadadditionalcities) ? _c('div', {
      staticClass: "col-md-6 "
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + data.key + 'citytocity'
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File (City to City)")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + data.key + 'citytocity',
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file"
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFile($event, 'ftl', data.key, 1)
        }
      }
    }), _vm._v("  \n                                    "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.ftlObject[data.key].filename) + "\n                                    "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('FileUpload')),
        expression: "errors.has('FileUpload')"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Choose file to upload")])])])], 1) : _vm._e()]), _vm._v(" "), (_vm.ftlObject[data.key].uploadadditionalcities) ? _c('div', [((_vm.ftlObject[data.key].ischanged == 0) && _vm.ftlObject[data.key].uploadadditionalcities) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForFtl(data.key, 1)
        }
      }
    }, [_vm._v("Download Sales TAT (Exceptional lanes) ")])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].filename != null) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateFile('ftl', data.key)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ftlObject[data.key].validdatacountzonetozone))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ftlObject[data.key].invaliddatacountzonetozone))])])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].isvalidated == 1 && _vm.ftlObject[data.key].invaliddatacount > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), (_vm.ftlObject[data.key].invaliddatacount > 0 && _vm.ftlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.ftlObject[data.key].tableColumn,
        "items": _vm.ftlObject[data.key].tableItems,
        "offset": _vm.ftlObject[data.key].offset
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ftlObject[data.key].totalPage > 1) ? _c('pagination', {
      attrs: {
        "total-pages": _vm.ftlObject[data.key].totalPage,
        "total": _vm.ftlObject[data.key].totalCount,
        "per-page": _vm.ftlObject[data.key].pageLimit,
        "current-page": _vm.ftlObject[data.key].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, 'ftl', data.key)
        }
      }
    }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ftlObject[data.key].error != ''),
        expression: "ftlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ftlObject[data.key].error))])]) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'PTL') ? _c('div', [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Select Service Type "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class='fa fa-credit-card'></i>"
      }
    }, [_c('treeselect', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.ServiceTypeDropdown,
        "placeholder": "Select Service Type",
        "append-to-body": true,
        "name": "servicetype"
      },
      on: {
        "select": function($event) {
          _vm.SelectServiceType($event, 'ptl', data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].servicetypezonetozonecitytocity),
        callback: function($$v) {
          _vm.ptlObject[data.key].servicetypezonetozonecitytocity = $$v
        },
        expression: "ptlObject[data.key].servicetypezonetozonecitytocity"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('servicetype')),
        expression: "errors.has('servicetype')"
      }],
      staticClass: "text-danger"
    }, [_vm._v("Please choose Service Type.")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.loadtab == 'PTL' && _vm.clientcontract == 0 && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 1) ? _c('div', [(data.routemode == 'Surface') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Select Service Level "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListCitytoCity,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": false
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error.serviceLevel),
        expression: "ptlObject[data.key].error.serviceLevel"
      }],
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error.serviceLevel))])], 1) : _vm._e(), _vm._v(" "), (data.routemode == 'Air') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Select Service Level "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.airServiceLevelListCitytoCity,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": false
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error.serviceLevel),
        expression: "ptlObject[data.key].error.serviceLevel"
      }],
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error.serviceLevel))])], 1) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].serviceLevel.id) ? _c('div', {
      staticClass: "col-md-7",
      staticStyle: {
        "padding": "20px 0px 15px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City) ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error != ''),
        expression: "ptlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error))])]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'PTL' && _vm.clientcontract == 0 && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 2) ? _c('div', [(data.routemode == 'Surface') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Select Service Level "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListZonetoZone,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": false
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error.serviceLevel),
        expression: "ptlObject[data.key].error.serviceLevel"
      }],
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error.serviceLevel))])], 1) : _vm._e(), _vm._v(" "), (data.routemode == 'Air') ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('label', [_vm._v("Select Service Level "), _c('span', {
      staticClass: "text-danger"
    }, [_vm._v(" *")])]), _vm._v(" "), _c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.airServiceLevelListZonetoZone,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": false
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error.serviceLevel),
        expression: "ptlObject[data.key].error.serviceLevel"
      }],
      staticClass: "text-danger"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error.serviceLevel))])], 1) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].serviceLevel.id) ? _c('div', {
      staticClass: "col-md-7",
      staticStyle: {
        "padding": "20px 0px 15px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone) ")])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error != ''),
        expression: "ptlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error))])]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'PTL' && _vm.clientcontract == 1 && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 1) ? _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ptlObject[data.key].UpdateSalesTatType),
        expression: "ptlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "ServiceLevelTemplate",
        "value": "ServiceLevelTemplate",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ptlObject[data.key].UpdateSalesTatType, "ServiceLevelTemplate")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ptl', data.key)
        },
        "__c": function($event) {
          _vm.ptlObject[data.key].UpdateSalesTatType = "ServiceLevelTemplate"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "ServiceLevelTemplate"
      }
    }, [_vm._v("Select Service Level ")]), _vm._v("     \n                                  ")])])])], 1), _vm._v(" "), (data.routemode == 'Surface') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListCitytoCity,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": _vm.ptlObject[data.key].UpdateSalesTatType == 'ServiceLevelTemplate' ? false : true
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (data.routemode == 'Air') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.airServiceLevelListCitytoCity,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": _vm.ptlObject[data.key].UpdateSalesTatType == 'ServiceLevelTemplate' ? false : true
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.ptlObject[data.key].servicetypezonetozonecitytocity == 1 && (_vm.ptlObject[data.key].showSalesTatDownload == true || _vm.ptlObject[data.key].serviceLevel.id) && (_vm.ptlObject[data.key].ischanged == 1))) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City) ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ptlObject[data.key].UpdateSalesTatType),
        expression: "ptlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "UploadFile",
        "value": "FileUpload",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ptlObject[data.key].UpdateSalesTatType, "FileUpload")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ptl', data.key)
        },
        "__c": function($event) {
          _vm.ptlObject[data.key].UpdateSalesTatType = "FileUpload"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _c('label', {
      attrs: {
        "for": "UploadFile"
      }
    }, [_vm._v("Upload File")])])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + data.key
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + data.key,
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file",
        "disabled": _vm.ptlObject[data.key].UpdateSalesTatType == 'FileUpload' ? false : true
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFile($event, 'ptl', data.key, null)
        }
      }
    }), _vm._v("  \n                                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.ptlObject[data.key].filename) + "\n                                  "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('FileUpload')),
        expression: "errors.has('FileUpload')"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Choose file to upload")])])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [((_vm.ptlObject[data.key].servicetypezonetozonecitytocity == 1 && (_vm.ptlObject[data.key].showSalesTatDownload == true || _vm.ptlObject[data.key].serviceLevel.id) && (_vm.ptlObject[data.key].ischanged == 0))) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 15px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (City to City)")])]) : _vm._e()]), _vm._v(" "), (_vm.ptlObject[data.key].filename != null) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateFile('ptl', data.key)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ptlObject[data.key].validdatacount))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ptlObject[data.key].invaliddatacount))])])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1 && _vm.ptlObject[data.key].invaliddatacount > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].invaliddatacount > 0 && _vm.ptlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.ptlObject[data.key].tableColumn,
        "items": _vm.ptlObject[data.key].tableItems,
        "offset": _vm.ptlObject[data.key].offset
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ptlObject[data.key].totalPage > 1) ? _c('pagination', {
      attrs: {
        "total-pages": _vm.ptlObject[data.key].totalPage,
        "total": _vm.ptlObject[data.key].totalCount,
        "per-page": _vm.ptlObject[data.key].pageLimit,
        "current-page": _vm.ptlObject[data.key].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, 'ptl', data.key)
        }
      }
    }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error != ''),
        expression: "ptlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error))])]) : _vm._e(), _vm._v(" "), (_vm.loadtab == 'PTL' && _vm.clientcontract == 1 && _vm.ptlObject[data.key].servicetypezonetozonecitytocity == 2) ? _c('div', [_c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ptlObject[data.key].UpdateSalesTatType),
        expression: "ptlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "ServiceLevelTemplate",
        "value": "ServiceLevelTemplate",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ptlObject[data.key].UpdateSalesTatType, "ServiceLevelTemplate")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ptl', data.key)
        },
        "__c": function($event) {
          _vm.ptlObject[data.key].UpdateSalesTatType = "ServiceLevelTemplate"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _vm._v(" "), _c('label', {
      attrs: {
        "for": "ServiceLevelTemplate"
      }
    }, [_vm._v("Select Service Level ")]), _vm._v("     \n                                  ")])])])], 1), _vm._v(" "), (data.routemode == 'Surface') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.surfServiceLevelListZonetoZone,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": _vm.ptlObject[data.key].UpdateSalesTatType == 'ServiceLevelTemplate' ? false : true
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (data.routemode == 'Air') ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', {
      attrs: {
        "left": "<i class=\"fa fa-level-up\"></i>"
      }
    }, [_c('treeselect', {
      attrs: {
        "clearable": false,
        "multiple": false,
        "max-height": 200,
        "options": _vm.airServiceLevelListZonetoZone,
        "placeholder": "Select Service Level",
        "append-to-body": true,
        "disabled": _vm.ptlObject[data.key].UpdateSalesTatType == 'ServiceLevelTemplate' ? false : true
      },
      on: {
        "select": function($event) {
          _vm.selectPTLServiceLevel($event, data.key)
        }
      },
      model: {
        value: (_vm.ptlObject[data.key].serviceLevel.id),
        callback: function($$v) {
          _vm.ptlObject[data.key].serviceLevel.id = $$v
        },
        expression: "ptlObject[data.key].serviceLevel.id"
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.ptlObject[data.key].servicetypezonetozonecitytocity == 2 && (_vm.ptlObject[data.key].showSalesTatDownloadzonetozone == true || _vm.ptlObject[data.key].serviceLevel.id) && (_vm.ptlObject[data.key].ischanged == 1))) ? _c('div', {
      staticClass: "col-md-3"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone) ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "radio"
    }, [_c('div', [_c('label', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ptlObject[data.key].UpdateSalesTatType),
        expression: "ptlObject[data.key].UpdateSalesTatType"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "radio",
        "id": "UploadFile",
        "value": "FileUpload",
        "name": "UpdateSalesTat"
      },
      domProps: {
        "checked": _vm._q(_vm.ptlObject[data.key].UpdateSalesTatType, "FileUpload")
      },
      on: {
        "change": function($event) {
          _vm.onChangeUpdateSalesTatType('ptl', data.key)
        },
        "__c": function($event) {
          _vm.ptlObject[data.key].UpdateSalesTatType = "FileUpload"
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _c('label', {
      attrs: {
        "for": "UploadFile"
      }
    }, [_vm._v("Upload File")])])])])], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-4"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + data.key
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + data.key,
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file",
        "disabled": _vm.ptlObject[data.key].UpdateSalesTatType == 'FileUpload' ? false : true
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFileZonetoZone($event, 'ptl', data.key)
        }
      }
    }), _vm._v("  \n                                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.ptlObject[data.key].filenamezonetozone) + "\n                                ")])])], 1)]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [((_vm.ptlObject[data.key].servicetypezonetozonecitytocity == 2 && (_vm.ptlObject[data.key].showSalesTatDownloadzonetozone == true || _vm.ptlObject[data.key].serviceLevel.id) && (_vm.ptlObject[data.key].ischanged == 0))) ? _c('div', {
      staticClass: "col-md-4",
      staticStyle: {
        "padding": "20px 0px 5px 0px"
      }
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key)
        }
      }
    }, [_vm._v("Download Sales TAT (Zone to Zone) ")])]) : _vm._e()]), _vm._v(" "), (_vm.ptlObject[data.key].isuploadzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateFileZoneToZone('ptl', data.key)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidatedzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidatedzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].totalrecordszonetozone))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("  " + _vm._s(_vm.ptlObject[data.key].validdatacountzonetozone))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ptlObject[data.key].invaliddatacountzonetozone))])])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1 && _vm.ptlObject[data.key].invaliddatacountzonetozone > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].invaliddatacountzonetozone > 0 && _vm.ptlObject[data.key].isvalidatedzonetozone == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.ptlObject[data.key].tableColumnzonetozone,
        "items": _vm.ptlObject[data.key].tableItemszonetozone,
        "offset": _vm.ptlObject[data.key].offset
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ptlObject[data.key].totalPagezonetozone > 1) ? _c('pagination', {
      attrs: {
        "total-pages": _vm.ptlObject[data.key].totalPagezonetozone,
        "total": _vm.ptlObject[data.key].totalCountzonetozone,
        "per-page": _vm.ptlObject[data.key].pageLimitzonetozone,
        "current-page": _vm.ptlObject[data.key].currentPagezonetozone
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, 'ptl', data.key)
        }
      }
    }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].errorzonetozone != ''),
        expression: "ptlObject[data.key].errorzonetozone!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("\n                            " + _vm._s(_vm.ptlObject[data.key].errorzonetozone))]), _vm._v(" "), _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-3"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "checkbox",
      attrs: {
        "left": "<i class='fa fa-credit-card'></i>"
      }
    }, [_c('label', {
      staticStyle: {
        "font-size": "1em"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.ptlObject[data.key].uploadadditionalcities),
        expression: "ptlObject[data.key].uploadadditionalcities"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: true
        }),
        expression: "{required: true}"
      }],
      class: {
        'form-control': true
      },
      attrs: {
        "type": "checkbox",
        "name": "Service Type",
        "value": "2"
      },
      domProps: {
        "checked": Array.isArray(_vm.ptlObject[data.key].uploadadditionalcities) ? _vm._i(_vm.ptlObject[data.key].uploadadditionalcities, "2") > -1 : (_vm.ptlObject[data.key].uploadadditionalcities)
      },
      on: {
        "click": function($event) {
          _vm.changecitytocity(data.key)
        },
        "__c": function($event) {
          var $$a = _vm.ptlObject[data.key].uploadadditionalcities,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = "2",
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.ptlObject[data.key].uploadadditionalcities = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.ptlObject[data.key].uploadadditionalcities = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.ptlObject[data.key].uploadadditionalcities = $$c
          }
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "cr",
      staticStyle: {
        "cursor": "pointer"
      }
    }, [_c('i', {
      staticClass: "cr-icon fa fa-check"
    })])]), _c('label', {
      attrs: {
        "for": "Commercial"
      }
    }, [_vm._v("Upload Exceptional lanes    ")])])])], 1), _vm._v(" "), (_vm.ptlObject[data.key].uploadadditionalcities) ? _c('div', {
      staticClass: "col-md-6"
    }, [_c('b-input-group', [_c('div', {
      staticClass: "file-upload"
    }, [_c('label', {
      staticStyle: {
        "color": "#fff",
        "cursor": "pointer"
      },
      attrs: {
        "for": 'FileUpload' + data.key + 'citytocity'
      }
    }, [_c('a', {
      staticClass: "-btn btn-info"
    }, [_vm._v(" Choose File(City to City)")])]), _vm._v(" "), _c('input', {
      ref: "files",
      refInFor: true,
      attrs: {
        "id": 'FileUpload' + data.key + 'citytocity',
        "name": "FileUpload",
        "accept": ".csv",
        "type": "file"
      },
      on: {
        "click": function($event) {
          $event.target.value = null
        },
        "change": function($event) {
          _vm.chooseFile($event, 'ptl', data.key, 1)
        }
      }
    }), _vm._v("  \n                                  "), _c('span', [_vm._v("Chosen File")]), _vm._v(": " + _vm._s(_vm.ptlObject[data.key].filename) + "\n                                  "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.errors.has('FileUpload')),
        expression: "errors.has('FileUpload')"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v("Choose file to upload")])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.ptlObject[data.key].uploadadditionalcities) ? _c('div', [((_vm.ptlObject[data.key].ischanged == 0) && _vm.ptlObject[data.key].uploadadditionalcities) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('button', {
      staticClass: "-btn btn-link",
      attrs: {
        "type": "button",
        "title": "Download Sales TAT"
      },
      on: {
        "click": function($event) {
          _vm.downloadFileForPtl(data.key, 1)
        }
      }
    }, [_vm._v("Download Sales TAT (Exceptional lanes) ")])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].filename != null) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('button', {
      staticClass: "-btn btn-primary",
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "type": "button",
        "title": "Validate File"
      },
      on: {
        "click": function($event) {
          _vm.validateFile('ptl', data.key)
        }
      }
    }, [_vm._v("Validate File")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Validation Results:")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-8"
    }, [_c('label', [_c('span', [_vm._v("Total Records: ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].totalrecords))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "green"
      }
    }, [_vm._v(" Valid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v("   " + _vm._s(_vm.ptlObject[data.key].validdatacount))]), _vm._v(" "), _c('span', [_vm._v(",")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v("Invalid Records:")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_vm._v(" " + _vm._s(_vm.ptlObject[data.key].invaliddatacount))])])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].isvalidated == 1 && _vm.ptlObject[data.key].invaliddatacount > 0) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-4"
    }, [_c('label', [_vm._v("Invalid records details:")])])]) : _vm._e(), _vm._v(" "), (_vm.ptlObject[data.key].invaliddatacount > 0 && _vm.ptlObject[data.key].isvalidated == 1) ? _c('div', {
      staticClass: "form-group row"
    }, [_c('div', {
      staticClass: "col-md-12"
    }, [_c('div', {
      staticStyle: {
        "overflow-x": "auto"
      }
    }, [_c('custom-expandable-table', {
      attrs: {
        "columns": _vm.ptlObject[data.key].tableColumn,
        "items": _vm.ptlObject[data.key].tableItems,
        "offset": _vm.ptlObject[data.key].offset
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.ptlObject[data.key].totalPage > 1) ? _c('pagination', {
      attrs: {
        "total-pages": _vm.ptlObject[data.key].totalPage,
        "total": _vm.ptlObject[data.key].totalCount,
        "per-page": _vm.ptlObject[data.key].pageLimit,
        "current-page": _vm.ptlObject[data.key].currentPage
      },
      on: {
        "pagechanged": function($event) {
          _vm.onPageChange($event, 'ptl', data.key)
        }
      }
    }) : _vm._e()], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.ptlObject[data.key].error != ''),
        expression: "ptlObject[data.key].error!=''"
      }],
      staticClass: "text-danger errormsg"
    }, [_vm._v(_vm._s(_vm.ptlObject[data.key].error))])]) : _vm._e()])]) : _vm._e()]) : _vm._e()])], 1)]) : _vm._e()]) : _vm._e()
  })], 2) : _vm._e(), _vm._v(" "), _c('br')])])]), _vm._v(" "), (_vm.showbutton) ? _c('span', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "-btn btn-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveContractServices('Save')
      }
    }
  }, [_vm._v("Save "), _c('i', {
    staticClass: "fa fa-save"
  })]), _vm._v(" "), (!(_vm.callingFromClientContract && _vm.callingFromClientContract.hideSaveNextButton)) ? _c('button', {
    staticClass: "-btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.saveContractServices('SaveServiceAndNext')
      }
    }
  }, [_vm._v("Save And Next "), _c('i', {
    staticClass: "fa fa-arrow-right"
  })]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br')])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-991c1de2","hasScoped":true}!./src/modules/shared/components/Template1/newservices/newservices.component.html
// module id = 662
// module chunks = 3